/**
 * 共通関数定義
 * 
 */

/**
 * サーバにLang設定取得
 * @param {string} key 
 * @returns json
 */
window.getLangSettingFromServer = function(key) {
    return $.ajax({
        url: '/resources/lang/get',
        type: "POST",
        dataType: 'json',
        data: { key: key }
    });
}

/**
 * サーバにLang設定取得 (async:false)
 * @param {string} key 
 * @returns json
 */
window.getLangSetting = async function(key) {
    return await getLangSettingFromServer(key);
}